/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 4/5/2015
 * Time: 3:07 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");

    //Template
    var template = require("user-management-templates/users/usersFooter.tmpl");
    var CONST = require("const");



    var UsersFooterView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        UsersFooterView = Marionette.ItemView.extend({
            isPermanent: true,
            className: "users-footer",
            template: template,
            ui:{
                backToListBtn: ".back-to-list-container",
                createNewContainer: ".create-new-container",
                createNewBtn: ".create-new-button"
            },
            events:{
                "click @ui.backToListBtn": "_backToList",
                "click @ui.createNewBtn": "_createNew"
            },

            initialize: function () {
                LEUserManagement.logger.debug("Initializing UsersFooterView", "UsersFooterView:initialize");
            },

            onRender: function() {
                this.isNavigationEnabled = true;
                this.ui.createNewContainer.toggleClass("disabled", LE.siteSettings.customizationSettings.isBlockAddUsers());
                this.listenTo(LEUserManagement.vent, "users:enableNavigation", this._enableNavigation);
            },

            onClose: function () {
                LEUserManagement.logger.debug("closing UsersFooterView", "UsersFooterView:onClose");
            },

            //private funcs:

            _backToList:function (ev) {
                LEUserManagement.logger.debug("Users footer: user clicked back to list button.", "UsersFooterView:_backToList");
                if (this.isNavigationEnabled) {
                    LEUserManagement.router.navigate("users");
                }
            },

            _createNew: function() {
                LEUserManagement.logger.debug("Users footer: user clicked create new button.", "UsersFooterView:_createEntity");
                if (this.isNavigationEnabled && !LE.siteSettings.customizationSettings.isBlockAddUsers()) {
                    LEUserManagement.router.navigate("users/" + CONST.ROUTING.NEW_ITEM_ID);
                }

            },

            _enableNavigation: function(enabled) {
                this.isNavigationEnabled = enabled;
            }

        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersFooterView;

});
